(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-cmp-blanket-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!window.ssCmpBlanketHeroReady) {
    window.ssCmpBlanketHeroReady = true;

    const initialiseBlanketHero = (scope = document) => {
      scope.querySelectorAll('[data-ss-cmp-blanket-hero]').forEach((hero) => {
        if (hero.dataset.heroReady) return;
        hero.dataset.heroReady = 'true';

        const track = hero.querySelector('[data-ss-cmp-blanket-track]');
        const slides = [...hero.querySelectorAll('[data-ss-cmp-blanket-slide]')];
        const tabs = [...hero.querySelectorAll('[data-ss-cmp-blanket-tab]')];
        const toggle = hero.querySelector('[data-ss-cmp-blanket-toggle]');
        const soundToggle = hero.querySelector('[data-ss-cmp-sound-toggle]');
        let muted = true;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let activeIndex = 0;
        let paused = reduceMotion;
        let inView = true;

        const activeVideo = () => slides[activeIndex]?.querySelector('.ss-cmp-blanket-hero__video');
        const updateSound = () => {
          const hasAudio = slides[activeIndex]?.dataset.hasAudio !== 'false';
          soundToggle.disabled = !hasAudio;
          soundToggle.setAttribute('aria-pressed', String(hasAudio && !muted));
          soundToggle.querySelector('span').textContent = !hasAudio ? hero.dataset.silentLabel : muted ? hero.dataset.soundOnLabel : hero.dataset.muteLabel;
          soundToggle.querySelector('[data-sound-slash]').toggleAttribute('hidden',hasAudio && !muted);
        };
        const updateToggle = () => {
          if (!toggle) return;
          toggle.textContent = paused ? '▶' : 'Ⅱ';
          toggle.setAttribute('aria-label', paused ? hero.dataset.playLabel : hero.dataset.pauseLabel);
        };

        const indexFromUrl = () => {
          const key = new URL(window.location.href).searchParams.get('blanket');
          const index = slides.findIndex((slide) => slide.dataset.blanketKey === key);
          return index < 0 ? 0 : index;
        };
        const showSlide = (index, updateUrl = true) => {
          if (!slides.length) return;
          activeIndex = (index + slides.length) % slides.length;
          if (updateUrl) {
            const url = new URL(window.location.href);
            url.searchParams.set('blanket', slides[activeIndex].dataset.blanketKey);
            window.history.replaceState(window.history.state, '', url);
          }
          hero.style.setProperty('--ss-cmp-active-accent', slides[activeIndex].dataset.slideAccent || '#4599d1');
          track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;
          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === activeIndex;
            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
            slide.toggleAttribute('inert', !isActive);
            const video = slide.querySelector('.ss-cmp-blanket-hero__video');
            if (!video) return;
            video.muted = muted;
            if (isActive && !paused && inView && !document.hidden) video.play().catch(() => {});
            else video.pause();
          });
          updateSound();
          tabs.forEach((tab, tabIndex) => {
            const isActive = tabIndex === activeIndex;
            tab.setAttribute('aria-selected', String(isActive));
            tab.tabIndex = isActive ? 0 : -1;
          });
        };

        tabs.forEach((tab, tabIndex) => {
          tab.addEventListener('click', () => showSlide(Number(tab.dataset.slideIndex)));
          tab.addEventListener('keydown', (event) => {
            let nextIndex = tabIndex;
            if (event.key === 'ArrowLeft') nextIndex = (tabIndex - 1 + tabs.length) % tabs.length;
            else if (event.key === 'ArrowRight') nextIndex = (tabIndex + 1) % tabs.length;
            else if (event.key === 'Home') nextIndex = 0;
            else if (event.key === 'End') nextIndex = tabs.length - 1;
            else return;

            event.preventDefault();
            showSlide(nextIndex);
            tabs[nextIndex]?.focus();
          });
        });
        hero.querySelector('[data-ss-cmp-blanket-previous]')?.addEventListener('click', () => showSlide(activeIndex - 1));
        hero.querySelector('[data-ss-cmp-blanket-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
        toggle?.addEventListener('click', () => {
          paused = !paused;
          const video = activeVideo();
          if (paused) video?.pause();
          else video?.play().catch(() => {});
          updateToggle();
        });

        soundToggle.addEventListener('click', () => {
          muted = !muted;
          const video = activeVideo();
          if (video) {
            video.muted = muted;
            if (!muted) { video.volume = 1; paused = false; video.play().catch(() => { paused = true; updateToggle(); }); }
          }
          updateSound();
          updateToggle();
        });
        updateToggle();
        showSlide(indexFromUrl(), false);
        window.addEventListener('popstate', () => showSlide(indexFromUrl(), false));
        const visibilityObserver = new IntersectionObserver((entries) => {
          inView = entries[0].isIntersecting;
          const video = activeVideo();
          if (inView && !paused && !document.hidden) video?.play().catch(() => {});
          else video?.pause();
        }, { threshold: 0.15 });
        visibilityObserver.observe(hero);
        document.addEventListener('visibilitychange', () => {
          const video = activeVideo();
          if (document.hidden) video?.pause();
          else if (inView && !paused) video?.play().catch(() => {});
        });
      });
    };

    initialiseBlanketHero();
    document.addEventListener('shopify:section:load', (event) => initialiseBlanketHero(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-cmp-blanket-quieter-craft"] && !Shopify.designMode) return;
  try {
    
  if (!window.ssCmpBlanketCraftReady) {
    window.ssCmpBlanketCraftReady = true;

    const initialiseBlanketCraft = (scope = document) => {
      scope.querySelectorAll('[data-ss-cmp-blanket-craft]').forEach((section) => {
        if (section.dataset.ssCraftReady) return;
        section.dataset.ssCraftReady = 'true';

        const scienceRail = section.querySelector('[data-ss-cmp-science-rail]');
        const scienceButtons = [...section.querySelectorAll('[data-ss-cmp-science-index]')];
        const scienceCards = [...(scienceRail?.querySelectorAll('.ss-cmp-craft-science__card') || [])];
        scienceButtons.forEach((button, index) => {
          button.addEventListener('click', () => {
            const offset = scienceCards[index].getBoundingClientRect().left - scienceRail.getBoundingClientRect().left;
            scienceRail.scrollBy({ left: offset });
          });
        });
        let scienceFrame;
        scienceRail?.addEventListener('scroll', () => {
          cancelAnimationFrame(scienceFrame);
          scienceFrame = requestAnimationFrame(() => {
            const railLeft = scienceRail.getBoundingClientRect().left;
            const distances = scienceCards.map((card) => Math.abs(card.getBoundingClientRect().left - railLeft));
            const activeIndex = distances.indexOf(Math.min(...distances));
            scienceButtons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === activeIndex)));
          });
        }, { passive: true });

        const rail = section.querySelector('[data-ss-cmp-craft-rail]');
        const previous = section.querySelector('[data-ss-cmp-craft-previous]');
        const next = section.querySelector('[data-ss-cmp-craft-next]');
        const move = (direction) => rail?.scrollBy({ left: direction * rail.clientWidth * 0.72 });

        previous?.addEventListener('click', () => move(-1));
        next?.addEventListener('click', () => move(1));
      });
    };

    initialiseBlanketCraft();
    document.addEventListener('shopify:section:load', (event) => initialiseBlanketCraft(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-cmp-clarity-choices"] && !Shopify.designMode) return;
  try {
    
  if (!window.ssCmpClarityChoiceGalleryReady) {
    window.ssCmpClarityChoiceGalleryReady = true;

    const initialiseComfortGalleries = (scope = document) => {
      scope.querySelectorAll('[data-ss-cmp-clarity-choice-gallery]').forEach((gallery) => {
        if (gallery.dataset.galleryReady) return;
        gallery.dataset.galleryReady = 'true';

        const track = gallery.querySelector('[data-ss-cmp-clarity-choice-track]');
        const slides = [...gallery.querySelectorAll('[data-ss-cmp-clarity-choice-slide]')];
        const count = gallery.querySelector('[data-ss-cmp-clarity-choice-count]');
        let activeIndex = 0;

        const showSlide = (index) => {
          if (!track || !slides.length) return;
          activeIndex = (index + slides.length) % slides.length;
          track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;
          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === activeIndex;
            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
          });
          if (count) count.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
        };

        gallery.querySelector('[data-ss-cmp-clarity-choice-previous]')?.addEventListener('click', () => showSlide(activeIndex - 1));
        gallery.querySelector('[data-ss-cmp-clarity-choice-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
        showSlide(0);
      });
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-ss-cmp-clarity-choice-jump]');
      if (!link) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      target.focus({preventScroll:true});
      target.scrollIntoView({block:'nearest',inline:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    });
    initialiseComfortGalleries();
    document.addEventListener('shopify:section:load', (event) => initialiseComfortGalleries(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-cmp-clarity-index"] && !Shopify.designMode) return;
  try {
    
  if (!window.ssCmpClarityIndexReady) {
    window.ssCmpClarityIndexReady = true;
    const initClarityIndex = (scope = document) => {
      scope.querySelectorAll('[data-ss-cmp-clarity-index]').forEach((section) => {
        if (section.dataset.ready) return;
        section.dataset.ready = 'true';
        const rail = section.querySelector('[data-ss-cmp-clarity-reason-rail]');
        const move = (direction) => rail?.scrollBy({left:direction * rail.clientWidth * .8});
        section.querySelector('[data-ss-cmp-clarity-reason-previous]')?.addEventListener('click',()=>move(-1));
        section.querySelector('[data-ss-cmp-clarity-reason-next]')?.addEventListener('click',()=>move(1));
      });
    };
    initClarityIndex();
    document.addEventListener('shopify:section:load',(event)=>initClarityIndex(event.target));
    document.addEventListener('click',(event)=>{
      const link = event.target.closest('[data-ss-cmp-clarity-index-select]');
      if (!link) return;
      const detail = {product_handle:link.dataset.productHandle,comparison_type:link.closest('[data-ss-cmp-clarity-index]')?.dataset.comparisonType || link.dataset.comparisonType || ''};
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event:'ss_compare_select',...detail});
      document.dispatchEvent(new CustomEvent('ss:compare-select',{detail}));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-cmp-clarity-shop"] && !Shopify.designMode) return;
  try {
    
  if (!window.ssCmpClarityShopReady) {
    window.ssCmpClarityShopReady = true;
    const initComparisonShop = (scope = document) => {
      scope.querySelectorAll('[data-ss-cmp-clarity-shop]').forEach((section) => {
        if (section.dataset.clarityShopReady) return;
        section.dataset.clarityShopReady = 'true';
        const variantImages = new Map();
        const refreshCartImages = () => {
          document.querySelectorAll('m-cart-drawer [data-quantity-variant-id]').forEach((input) => {
            const variant = variantImages.get(input.dataset.quantityVariantId);
            const image = input.closest('[data-cart-item]')?.querySelector('.m-cart-item__image img');
            if (variant?.image && image) {
              image.removeAttribute('srcset');
              image.src = variant.image;
              image.alt = variant.alt;
              const responsiveImage = image.closest('responsive-image');
              if (responsiveImage) responsiveImage.src = image.src;
            }
          });
        };
        section.querySelectorAll('[data-clarity-shop-card]').forEach((card) => {
          if (card.dataset.enhanced) return;
          const form = card.querySelector('[data-clarity-shop-form]');
          const selector = card.querySelector('[data-clarity-shop-variant]');
          const variants = [...selector.options].map((option) => ({id:option.value,options:JSON.parse(option.dataset.options),available:option.dataset.available === 'true',price:option.dataset.price,compare:option.dataset.compare,image:option.dataset.image,alt:option.dataset.imageAlt}));
          variants.forEach((variant) => variantImages.set(variant.id,variant));
          const groups = [...card.querySelectorAll('[data-clarity-shop-option]')];
          const add = card.querySelector('[name="add"]');
          const status = card.querySelector('[data-clarity-shop-status]');
          const cartLink = card.querySelector('[data-clarity-shop-cart]');
          let busy = false;
          let current;
          const sync = () => {
            const values = groups.map((group) => group.querySelector('input:checked')?.value);
            current = variants.find((variant) => variant.options.every((value,index) => value === values[index]));
            selector.value = current?.id || '';
            card.querySelector('[data-clarity-shop-price]').textContent = current?.price || '—';
            const compare = card.querySelector('[data-clarity-shop-compare]');
            compare.textContent = current?.compare || '';
            compare.hidden = !current?.compare;
            add.disabled = busy || !current?.available;
            add.textContent = busy ? section.dataset.addingLabel : current?.available ? section.dataset.addLabel : current ? section.dataset.soldLabel : section.dataset.unavailableLabel;
            groups.forEach((group,index) => {
              const valueLabel = group.querySelector('[data-clarity-shop-option-value]');
              if (valueLabel) valueLabel.textContent = values[index] || '';
              group.querySelectorAll('input').forEach((input) => {
                const possible = variants.some((variant) => variant.available && variant.options[index] === input.value && variant.options.slice(0,index).every((value,previous) => value === values[previous]));
                input.disabled = busy || !possible;
              });
            });
            if (current) {
              const contents = card.querySelector('[data-clarity-shop-pillowcases]');
              if (contents) contents.textContent = current.options.includes('Single') ? contents.dataset.one : contents.dataset.two;
              const image = card.querySelector('.ss-cmp-clarity-shop__image > img');
              if (image && current.image) { image.removeAttribute('srcset'); image.src = current.image; image.alt = current.alt; }
              card.querySelectorAll('[data-clarity-shop-product-link]').forEach((link) => { const url = new URL(link.href); url.searchParams.set('variant',current.id); link.href = url.href; });
            }
          };
          groups.forEach((group) => group.addEventListener('change', () => {
            status.textContent = '';
            status.removeAttribute('data-error');
            if (cartLink) cartLink.hidden = true;
            sync();
            if (!current?.available) status.textContent = current ? section.dataset.soldLabel : section.dataset.unavailableLabel;
          }));
          form.addEventListener('submit', async (event) => {
            event.preventDefault();
            if (busy || !current?.available) return;
            const selectedId = current.id;
            busy = true;
            status.textContent = '';
            status.removeAttribute('data-error');
            if (cartLink) cartLink.hidden = true;
            sync();
            let added = false;
            let rejected = false;
            try {
              const sections = [];
              document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections',{bubbles:true,detail:{sections}}));
              const data = new FormData(form);
              data.set('id',selectedId);
              data.set('quantity','1');
              data.set('sections',[...new Set(sections)].slice(0,5).join(','));
              data.set('sections_url',window.location.pathname);
              const response = await fetch(form.action.replace(/\/add(?:\.js)?$/, '/add.js'), {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
              const result = await response.json();
              if (!response.ok || result.status) { rejected = true; throw new Error(typeof result.description === 'string' ? result.description : section.dataset.errorLabel); }
              added = true;
              status.textContent = section.dataset.successLabel;
              if (cartLink) cartLink.hidden = false;
              try {
                if (window.wcmmgEvents && window.wcmmgTheme?.pubSubEvents?.cartUpdate) window.wcmmgEvents.emit(window.wcmmgTheme.pubSubEvents.cartUpdate,{cart:result,productVariantId:selectedId});
                const drawer = document.querySelector('m-cart-drawer');
                if (drawer && window.wcmmgSettings?.enable_cart_drawer) drawer.open(add);
                document.dispatchEvent(new CustomEvent('product-ajax:added',{detail:{product:result}}));
              } catch (error) { status.textContent = cartLink ? section.dataset.successLabel + ' ' + section.dataset.reviewLabel : section.dataset.successLabel; }
            } catch (error) {
              status.textContent = added ? section.dataset.successLabel : rejected ? error.message : section.dataset.errorLabel;
              status.toggleAttribute('data-error',!added);
              if (cartLink) cartLink.hidden = false;
            } finally { busy = false; sync(); }
          });
          card.querySelector('[data-clarity-shop-options]').hidden = false;
          card.dataset.enhanced = 'true';
          sync();
        });
        refreshCartImages();
        document.addEventListener('cart:updated',refreshCartImages);
      });
    };
    initComparisonShop();
    document.addEventListener('shopify:section:load',(event) => initComparisonShop(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-cmp-comparison-shop"] && !Shopify.designMode) return;
  try {
    
  if (!window.ssCmpComparisonShopReady) {
    window.ssCmpComparisonShopReady = true;
    const initComparisonShop = (scope = document) => {
      scope.querySelectorAll('[data-ss-cmp-comparison-shop]').forEach((section) => {
        if (section.dataset.shopReady) return;
        section.dataset.shopReady = 'true';
        const variantImages = new Map();
        const refreshCartImages = () => {
          document.querySelectorAll('m-cart-drawer [data-quantity-variant-id]').forEach((input) => {
            const variant = variantImages.get(input.dataset.quantityVariantId);
            const image = input.closest('[data-cart-item]')?.querySelector('.m-cart-item__image img');
            if (variant?.image && image) {
              image.removeAttribute('srcset');
              image.src = variant.image;
              image.alt = variant.alt;
              const responsiveImage = image.closest('responsive-image');
              if (responsiveImage) responsiveImage.src = image.src;
            }
          });
        };
        section.querySelectorAll('[data-shop-card]').forEach((card) => {
          if (card.dataset.enhanced) return;
          const form = card.querySelector('[data-shop-form]');
          const selector = card.querySelector('[data-shop-variant]');
          const variants = [...selector.options].map((option) => ({id:option.value,options:JSON.parse(option.dataset.options),available:option.dataset.available === 'true',price:option.dataset.price,compare:option.dataset.compare,image:option.dataset.image,alt:option.dataset.imageAlt}));
          variants.forEach((variant) => variantImages.set(variant.id,variant));
          const groups = [...card.querySelectorAll('[data-shop-option]')];
          const add = card.querySelector('[name="add"]');
          const status = card.querySelector('[data-shop-status]');
          const cartLink = card.querySelector('[data-shop-cart]');
          let busy = false;
          let current;
          const sync = () => {
            const values = groups.map((group) => group.querySelector('input:checked')?.value);
            current = variants.find((variant) => variant.options.every((value,index) => value === values[index]));
            selector.value = current?.id || '';
            card.querySelector('[data-shop-price]').textContent = current?.price || '—';
            const compare = card.querySelector('[data-shop-compare]');
            compare.textContent = current?.compare || '';
            compare.hidden = !current?.compare;
            add.disabled = busy || !current?.available;
            add.textContent = busy ? section.dataset.addingLabel : current?.available ? section.dataset.addLabel : current ? section.dataset.soldLabel : section.dataset.unavailableLabel;
            groups.forEach((group,index) => {
              const valueLabel = group.querySelector('[data-shop-option-value]');
              if (valueLabel) valueLabel.textContent = values[index] || '';
              group.querySelectorAll('input').forEach((input) => {
                const possible = variants.some((variant) => variant.available && variant.options[index] === input.value && variant.options.slice(0,index).every((value,previous) => value === values[previous]));
                input.disabled = busy || !possible;
              });
            });
            if (current) {
              const image = card.querySelector('.ss-cmp-comparison-shop__image > img');
              if (image && current.image) { image.removeAttribute('srcset'); image.src = current.image; image.alt = current.alt; }
              card.querySelectorAll('[data-shop-product-link]').forEach((link) => { const url = new URL(link.href); url.searchParams.set('variant',current.id); link.href = url.href; });
            }
          };
          groups.forEach((group) => group.addEventListener('change', () => {
            status.textContent = '';
            status.removeAttribute('data-error');
            if (cartLink) cartLink.hidden = true;
            sync();
            if (!current?.available) status.textContent = current ? section.dataset.soldLabel : section.dataset.unavailableLabel;
          }));
          form.addEventListener('submit', async (event) => {
            event.preventDefault();
            if (busy || !current?.available) return;
            const selectedId = current.id;
            busy = true;
            status.textContent = '';
            status.removeAttribute('data-error');
            if (cartLink) cartLink.hidden = true;
            sync();
            let added = false;
            let rejected = false;
            try {
              const sections = [];
              document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections',{bubbles:true,detail:{sections}}));
              const data = new FormData(form);
              data.set('id',selectedId);
              data.set('quantity','1');
              data.set('sections',[...new Set(sections)].slice(0,5).join(','));
              data.set('sections_url',window.location.pathname);
              const response = await fetch(form.action.replace(/\/add(?:\.js)?$/, '/add.js'), {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
              const result = await response.json();
              if (!response.ok || result.status) { rejected = true; throw new Error(typeof result.description === 'string' ? result.description : section.dataset.errorLabel); }
              added = true;
              status.textContent = section.dataset.successLabel;
              if (cartLink) cartLink.hidden = false;
              try {
                if (window.wcmmgEvents && window.wcmmgTheme?.pubSubEvents?.cartUpdate) window.wcmmgEvents.emit(window.wcmmgTheme.pubSubEvents.cartUpdate,{cart:result,productVariantId:selectedId});
                const drawer = document.querySelector('m-cart-drawer');
                if (drawer && window.wcmmgSettings?.enable_cart_drawer) drawer.open(add);
                document.dispatchEvent(new CustomEvent('product-ajax:added',{detail:{product:result}}));
              } catch (error) { status.textContent = cartLink ? section.dataset.successLabel + ' ' + section.dataset.reviewLabel : section.dataset.successLabel; }
            } catch (error) {
              status.textContent = added ? section.dataset.successLabel : rejected ? error.message : section.dataset.errorLabel;
              status.toggleAttribute('data-error',!added);
              if (cartLink) cartLink.hidden = false;
            } finally { busy = false; sync(); }
          });
          card.querySelector('[data-shop-options]').hidden = false;
          card.dataset.enhanced = 'true';
          sync();
        });
        refreshCartImages();
        document.addEventListener('cart:updated',refreshCartImages);
      });
    };
    initComparisonShop();
    document.addEventListener('shopify:section:load',(event) => initComparisonShop(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-cmp-product-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!window.ssCmpCompareExperienceReady) {
    window.ssCmpCompareExperienceReady = true;

    const initialiseComparison = (scope = document) => {
      scope.querySelectorAll('[data-ss-cmp-compare]').forEach((comparison) => {
        if (comparison.dataset.ssCompareReady) return;
        comparison.dataset.ssCompareReady = 'true';

        const rail = comparison.querySelector('[data-ss-cmp-compare-rail]');
        const cards = [...comparison.querySelectorAll('[data-ss-cmp-compare-card]')];
        const previous = comparison.querySelector('[data-ss-cmp-compare-previous]');
        const next = comparison.querySelector('[data-ss-cmp-compare-next]');
        const count = comparison.querySelector('[data-ss-cmp-compare-count]');
        const reasonRail = comparison.querySelector('[data-ss-cmp-reason-rail]');
        const reasonPrevious = comparison.querySelector('[data-ss-cmp-reason-previous]');
        const reasonNext = comparison.querySelector('[data-ss-cmp-reason-next]');
        const move = (direction) => rail && rail.scrollBy({ left: direction * rail.clientWidth * 0.76 });
        const moveReason = (direction) => reasonRail?.scrollBy({ left: direction * reasonRail.clientWidth * 0.72 });

        previous?.addEventListener('click', () => move(-1));
        next?.addEventListener('click', () => move(1));
        reasonPrevious?.addEventListener('click', () => moveReason(-1));
        reasonNext?.addEventListener('click', () => moveReason(1));

        const updateCount = () => {
          if (!rail || !count || cards.length === 0) return;
          const railLeft = rail.getBoundingClientRect().left;
          const activeIndex = cards.reduce((best, card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - railLeft);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity }).index;
          count.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
        };

        rail?.addEventListener('scroll', updateCount, { passive: true });
        updateCount();
      });
    };

    initialiseComparison();
    document.addEventListener('shopify:section:load', (event) => initialiseComparison(event.target));

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-ss-cmp-compare-select]');
      if (!link) return;
      const comparison = link.closest('[data-ss-cmp-compare]');
      const detail = {
        product_handle: link.dataset.productHandle,
        comparison_type: comparison ? comparison.dataset.comparisonType : (link.dataset.comparisonType || '')
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'ss_compare_select', ...detail });
      document.dispatchEvent(new CustomEvent('ss:compare-select', { detail }));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-cmp-quieter-craft-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!window.ssCmpQuieterReviewsReady) {
    window.ssCmpQuieterReviewsReady = true;

    const initialiseReviewRails = (scope = document) => {
      scope.querySelectorAll('[data-ss-cmp-quieter-reviews]').forEach((section) => {
        if (section.dataset.ssReviewsReady) return;
        section.dataset.ssReviewsReady = 'true';
        const rail = section.querySelector('[data-ss-cmp-review-rail]');
        const move = (direction) => rail && rail.scrollBy({ left: direction * rail.clientWidth * 0.76 });
        section.querySelector('[data-ss-cmp-review-previous]')?.addEventListener('click', () => move(-1));
        section.querySelector('[data-ss-cmp-review-next]')?.addEventListener('click', () => move(1));
      });
    };

    initialiseReviewRails();
    document.addEventListener('shopify:section:load', (event) => initialiseReviewRails(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-cmp-sheet-comfort-simple"] && !Shopify.designMode) return;
  try {
    
  if (!window.ssCmpSheetComfortGalleryReady) {
    window.ssCmpSheetComfortGalleryReady = true;

    const initialiseComfortGalleries = (scope = document) => {
      scope.querySelectorAll('[data-ss-cmp-sheet-comfort-gallery]').forEach((gallery) => {
        if (gallery.dataset.galleryReady) return;
        gallery.dataset.galleryReady = 'true';

        const track = gallery.querySelector('[data-ss-cmp-sheet-comfort-track]');
        const slides = [...gallery.querySelectorAll('[data-ss-cmp-sheet-comfort-slide]')];
        const count = gallery.querySelector('[data-ss-cmp-sheet-comfort-count]');
        let activeIndex = 0;

        const showSlide = (index) => {
          if (!track || !slides.length) return;
          activeIndex = (index + slides.length) % slides.length;
          track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;
          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === activeIndex;
            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
          });
          if (count) count.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
        };

        gallery.querySelector('[data-ss-cmp-sheet-comfort-previous]')?.addEventListener('click', () => showSlide(activeIndex - 1));
        gallery.querySelector('[data-ss-cmp-sheet-comfort-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
        showSlide(0);
      });
    };

    initialiseComfortGalleries();
    document.addEventListener('shopify:section:load', (event) => initialiseComfortGalleries(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-cmp-sheet-films"] && !Shopify.designMode) return;
  try {
    
  if (!window.ssCmpSheetFilmsReady) {
    window.ssCmpSheetFilmsReady = true;
    const initSheetFilms = (scope = document) => {
      scope.querySelectorAll('[data-sheet-films]').forEach((section) => {
        if (section.dataset.ready) return;
        section.dataset.ready = 'true';
        const rail = section.querySelector('[data-sheet-film-rail]');
        const videos = [...section.querySelectorAll('video')];
        const step = (direction) => rail.scrollBy({left:direction * (rail.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap))});
        section.querySelector('[data-sheet-film-prev]').addEventListener('click', () => step(-1));
        section.querySelector('[data-sheet-film-next]').addEventListener('click', () => step(1));
        videos.forEach((video) => {
          const button = video.parentElement.querySelector('[data-sheet-film-play]');
          button.addEventListener('click', () => { video.muted = false; video.volume = 1; video.play().then(() => { button.hidden = true; video.focus(); }).catch(() => {}); });
          video.addEventListener('play', () => {
            button.hidden = true;
            videos.forEach((other) => { if (other !== video) other.pause(); });
          });
          video.addEventListener('ended', () => { button.hidden = false; });
        });
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (!entry.isIntersecting) entry.target.pause(); }), {threshold:0.2});
        videos.forEach((video) => observer.observe(video));
        document.addEventListener('visibilitychange', () => { if (document.hidden) videos.forEach((video) => video.pause()); });
      });
    };
    initSheetFilms();
    document.addEventListener('shopify:section:load', (event) => initSheetFilms(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-cmp-sheet-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!window.ssCmpSheetHeroReady) {
    window.ssCmpSheetHeroReady = true;

    const initialiseSheetHero = (scope = document) => {
      scope.querySelectorAll('[data-ss-cmp-sheet-hero]').forEach((hero) => {
        if (hero.dataset.heroReady) return;
        hero.dataset.heroReady = 'true';

        const track = hero.querySelector('[data-ss-cmp-sheet-track]');
        const slides = [...hero.querySelectorAll('[data-ss-cmp-sheet-slide]')];
        const tabs = [...hero.querySelectorAll('[data-ss-cmp-sheet-tab]')];
        const toggle = hero.querySelector('[data-ss-cmp-sheet-toggle]');
        const soundToggle = hero.querySelector('[data-ss-cmp-sound-toggle]');
        let muted = true;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let activeIndex = 0;
        let paused = reduceMotion;
        let inView = true;

        const activeVideo = () => slides[activeIndex]?.querySelector('.ss-cmp-sheet-hero__video');
        const updateSound = () => {
          const hasAudio = slides[activeIndex]?.dataset.hasAudio !== 'false';
          soundToggle.disabled = !hasAudio;
          soundToggle.setAttribute('aria-pressed', String(hasAudio && !muted));
          soundToggle.querySelector('span').textContent = !hasAudio ? hero.dataset.silentLabel : muted ? hero.dataset.soundOnLabel : hero.dataset.muteLabel;
          soundToggle.querySelector('[data-sound-slash]').toggleAttribute('hidden',hasAudio && !muted);
        };
        const updateToggle = () => {
          if (!toggle) return;
          toggle.textContent = paused ? '▶' : 'Ⅱ';
          toggle.setAttribute('aria-label', paused ? hero.dataset.playLabel : hero.dataset.pauseLabel);
        };

        const showSlide = (index) => {
          if (!slides.length) return;
          activeIndex = (index + slides.length) % slides.length;
          hero.style.setProperty('--ss-cmp-active-accent', slides[activeIndex].dataset.slideAccent || '#4599d1');
          track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;
          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === activeIndex;
            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
            slide.toggleAttribute('inert', !isActive);
            const video = slide.querySelector('.ss-cmp-sheet-hero__video');
            if (!video) return;
            video.muted = muted;
            if (isActive && !paused && inView && !document.hidden) video.play().catch(() => {});
            else video.pause();
          });
          updateSound();
          tabs.forEach((tab, tabIndex) => {
            const isActive = tabIndex === activeIndex;
            tab.setAttribute('aria-selected', String(isActive));
            tab.tabIndex = isActive ? 0 : -1;
          });
        };

        tabs.forEach((tab, tabIndex) => {
          tab.addEventListener('click', () => showSlide(Number(tab.dataset.slideIndex)));
          tab.addEventListener('keydown', (event) => {
            let nextIndex = tabIndex;
            if (event.key === 'ArrowLeft') nextIndex = (tabIndex - 1 + tabs.length) % tabs.length;
            else if (event.key === 'ArrowRight') nextIndex = (tabIndex + 1) % tabs.length;
            else if (event.key === 'Home') nextIndex = 0;
            else if (event.key === 'End') nextIndex = tabs.length - 1;
            else return;

            event.preventDefault();
            showSlide(nextIndex);
            tabs[nextIndex]?.focus();
          });
        });
        hero.querySelector('[data-ss-cmp-sheet-previous]')?.addEventListener('click', () => showSlide(activeIndex - 1));
        hero.querySelector('[data-ss-cmp-sheet-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
        toggle?.addEventListener('click', () => {
          paused = !paused;
          const video = activeVideo();
          if (paused) video?.pause();
          else video?.play().catch(() => {});
          updateToggle();
        });

        soundToggle.addEventListener('click', () => {
          muted = !muted;
          const video = activeVideo();
          if (video) {
            video.muted = muted;
            if (!muted) { video.volume = 1; paused = false; video.play().catch(() => { paused = true; updateToggle(); }); }
          }
          updateSound();
          updateToggle();
        });
        updateToggle();
        showSlide(0);
        const visibilityObserver = new IntersectionObserver((entries) => {
          inView = entries[0].isIntersecting;
          const video = activeVideo();
          if (inView && !paused && !document.hidden) video?.play().catch(() => {});
          else video?.pause();
        }, { threshold: 0.15 });
        visibilityObserver.observe(hero);
        document.addEventListener('visibilitychange', () => {
          const video = activeVideo();
          if (document.hidden) video?.pause();
          else if (inView && !paused) video?.play().catch(() => {});
        });
      });
    };

    initialiseSheetHero();
    document.addEventListener('shopify:section:load', (event) => initialiseSheetHero(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-cmp-sheet-quieter-craft"] && !Shopify.designMode) return;
  try {
    
  if (!window.ssCmpSheetCraftReady) {
    window.ssCmpSheetCraftReady = true;
    const initSheetCraft = (scope = document) => {
      scope.querySelectorAll('[data-ss-cmp-sheet-craft]').forEach((section) => {
        if (section.dataset.ready) return;
        section.dataset.ready = 'true';
        const rail = section.querySelector('[data-sheet-craft-rail]');
        const cards = [...rail.children];
        const buttons = [...section.querySelectorAll('[data-sheet-craft-index]')];
        buttons.forEach((button, index) => button.addEventListener('click', () => {
          rail.scrollBy({ left: cards[index].getBoundingClientRect().left - rail.getBoundingClientRect().left });
        }));
        let frame;
        rail.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const distances = cards.map((card) => Math.abs(card.getBoundingClientRect().left - rail.getBoundingClientRect().left));
            const active = distances.indexOf(Math.min(...distances));
            buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === active)));
          });
        }, { passive:true });
      });
    };
    initSheetCraft();
    document.addEventListener('shopify:section:load', (event) => initSheetCraft(event.target));
  }

  } catch(e) { console.error(e); }
})();
})();
